// 🔧 event_page_seo_helpers.js
// ✅ Purpose: Shared helper for approved event-level SEO pages
// ✅ Features:
// - Reads SEO from eventDoc.seoPages by page key
// - Only uses SEO content when status is approved
// - Falls back to safe page defaults when SEO is missing, pending, or rejected
// - Avoids extra Firestore reads because eventDoc is already loaded by public pages
// - Supports core and enabled event Power Up page keys
// - Fully block-commented for clarity and future devs

import { isEventPublic } from "./event_visibility";

// ✅ Returns true only when the SEO page has been approved.
// ✅ This prevents AI-generated draft content from going public too early.
export const hasApprovedSeoPage = (eventDoc, pageKey) => {
  return eventDoc?.seoPages?.[pageKey]?.status === "approved";
};

// ✅ Builds safe SEO values for event-level public pages.
// ✅ Approved SEO wins.
// ✅ Otherwise, fallback values keep the page safe and indexable when publicSeo is true.
export const buildEventPageSeo = ({
  eventDoc,
  pageKey,
  fallbackTitle,
  fallbackDescription,
  fallbackImage,
}) => {
  const seoPage = eventDoc?.seoPages?.[pageKey] || {};
  const approved = hasApprovedSeoPage(eventDoc, pageKey);

  return {
    title: approved && seoPage.title
      ? seoPage.title
      : fallbackTitle,

    description: approved && seoPage.description
      ? seoPage.description
      : fallbackDescription,

    image:
      fallbackImage ||
      eventDoc?.eventLogo ||
      "https://letsgovote.app/images/social-share-default.png",

    noindex: !isEventPublic(eventDoc),
  };
};
